// Product gallery: thumbnail buttons scroll the rounded slide track and mark the visible slide.
class ProductGallery extends HTMLElement {
  #abort = null;

  connectedCallback() {
    this.#abort = new AbortController();
    const { signal } = this.#abort;
    this.track = this.querySelector('[data-gallery-track]');
    this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
    if (!this.track) return;

    this.addEventListener('command', (event) => {
      if (event.command !== '--go') return;
      const index = Number(event.source?.dataset.index || 0);
      this.#goTo(index);
    }, { signal });

    this.track.addEventListener('scroll', () => {
      cancelAnimationFrame(this.raf);
      this.raf = requestAnimationFrame(() => this.#syncActive());
    }, { passive: true, signal });
  }

  disconnectedCallback() {
    this.#abort?.abort();
    cancelAnimationFrame(this.raf);
  }

  #goTo(index) {
    const slide = this.track.children[index];
    if (!slide) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    this.#setActive(index);
  }

  #syncActive() {
    const width = this.track.clientWidth || 1;
    const index = Math.round(Math.abs(this.track.scrollLeft) / width);
    this.#setActive(index);
  }

  #setActive(index) {
    this.thumbs.forEach((thumb, i) => {
      if (i === index) thumb.setAttribute('aria-current', 'true');
      else thumb.removeAttribute('aria-current');
    });
  }
}

if (!customElements.get('s-product-gallery')) customElements.define('s-product-gallery', ProductGallery);
